import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function ReparerPlutot() {
  return (
    <section className="bg-[#F4F8FB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Réparer plutôt que remplacer
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Avant de remplacer les lames ou le tablier, nos techniciens vérifient toujours la cause exacte du dommage. Parfois, le problème ne vient pas du tablier lui-même, mais de glissières déformées, d'un mauvais alignement des lames ou d'une butée de fin de course mal réglée. Remplacer sans régler la cause sous-jacente conduirait à une nouvelle dégradation prématurée.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Nous inspectons l'ensemble du mécanisme : l'état des glissières latérales, le bon alignement du tablier, la fluidité de l'enroulement dans le coffre et l'absence de point dur. Si le problème vient d'une pièce autre que le tablier, nous vous proposons la réparation adaptée pour une solution durable.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-8">
              Notre approche est simple : diagnostiquer avant d'intervenir, pour ne remplacer que ce qui est nécessaire et vous éviter des frais inutiles. C'est aussi cela notre engagement de réparateur professionnel à Strasbourg.
            </p>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Technician%20performing%20a%20detailed%20diagnostic%20inspection%20on%20a%20white%20roller%20shutter%20tablier%20using%20precision%20tools%20and%20a%20measuring%20tape%20in%20a%20clean%20workshop%20environment%20bright%20lighting%20warm%20neutral%20tones%20professional%20service%20photography&width=700&height=520&seq=tab-diag&orientation=landscape" alt="Diagnostic d'un tablier de volet roulant à Strasbourg" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}